import styled, { css } from 'styled-components'
import { ReactComponent as GoogleFile } from '../../../../assets/icons/google.svg'

export const GoogleIcon = styled(GoogleFile)`
  width: 20px;
  height: 20px;
  margin: 0;
  flex-shrink: 0;
  color: #a9e8fc;

  path {
    fill: currentColor;
  }

  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
  }
`

export const FacebookIcon = styled.img`
  width: 20px;
  height: 20px;
  margin: 0;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 8px;

  @media (min-width: 768px) {
    margin-top: 4px;
  }
`

export const TitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  width: 100%;
  margin: 8px 0 16px;

  @media (min-width: 768px) {
    margin: 12px 0 20px;
  }
`

export const SemiDivider = styled.div`
  border-bottom: 1px solid #9b96a7;
  flex: 1;
`

export const Text = styled.p`
  color: #9b96a7;
  font-size: 14px;
  font-weight: 400;
  margin: 0 12px;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 16px;
    margin: 0 16px;
  }
`

export const HelperText = styled.p`
  color: #9b96a7;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  margin: 8px 0 0;
  width: 100%;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`

export const SocialLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;

  > div {
    width: 100%;
  }
`

export const SocialLoginButton = styled.div`
  ${({ theme }) => css`
    background: transparent;
    border: 1px solid #a9e8fc;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 16px;
    padding: 12px 16px;
    cursor: pointer;
    width: 100%;
    min-height: 48px;
    box-sizing: border-box;
    transition: opacity 0.3s ease;

    > span {
      color: #a9e8fc;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
    }

    &:hover {
      opacity: 0.9;
    }

    @media (min-width: 768px) {
      gap: 12px;
      min-height: 52px;

      > span {
        font-size: 16px;
        line-height: 24px;
      }
    }
  `}
`
